import type { ComponentType, PropsWithChildren } from 'react';

import { VBaseCheckboxRadioGroup } from '../VBaseCheckboxRadioGroup';
import VCheckbox from '../VCheckbox/VCheckbox';
import type { VCheckboxGroupItemProps } from '../VCheckbox/type';
import type { VCheckboxGroupProps } from './type';

const VCheckboxGroup = ({
  children,
  defaultValue,
  value,
  onValueChange,
}: PropsWithChildren<VCheckboxGroupProps>) => {
  return (
    <VBaseCheckboxRadioGroup
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      {children}
    </VBaseCheckboxRadioGroup>
  );
};

VCheckboxGroup.Item = VCheckbox as ComponentType<VCheckboxGroupItemProps>;

export default VCheckboxGroup;
